/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventLocalAudioStatsMeasuredFromJSON(json) {
    return StreemApiAnalyticEventLocalAudioStatsMeasuredFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventLocalAudioStatsMeasuredFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'packetsLost': !exists(json, 'packets_lost') ? undefined : json['packets_lost'],
        'codec': !exists(json, 'codec') ? undefined : json['codec'],
        'bytesSent': !exists(json, 'bytes_sent') ? undefined : json['bytes_sent'],
        'packetsSent': !exists(json, 'packets_sent') ? undefined : json['packets_sent'],
        'roundTripTimeMs': !exists(json, 'round_trip_time_ms') ? undefined : json['round_trip_time_ms'],
        'audioLevel': !exists(json, 'audio_level') ? undefined : json['audio_level'],
        'jitterMs': !exists(json, 'jitter_ms') ? undefined : json['jitter_ms'],
        'trackSid': !exists(json, 'track_sid') ? undefined : json['track_sid'],
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
    };
}
export function StreemApiAnalyticEventLocalAudioStatsMeasuredToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'packets_lost': value.packetsLost,
        'codec': value.codec,
        'bytes_sent': value.bytesSent,
        'packets_sent': value.packetsSent,
        'round_trip_time_ms': value.roundTripTimeMs,
        'audio_level': value.audioLevel,
        'jitter_ms': value.jitterMs,
        'track_sid': value.trackSid,
        'room_sid': value.roomSid,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventLocalAudioStatsMeasured.js.map